/**
 * PC端和手机端都使用这个http
 *
 * PC端限制使用前端框架为iView, 手机端限制使用框架为vux, 判断方式为在state中增加iview和vux的模块
 */
import societyApi from './api'
import axios from 'axios'
import store from './store'
import Vue from 'vue'
import lodash from 'lodash'

// base可以通过societyApi读取index.html中的配置值
const _http = axios.create({baseURL: societyApi.baseUrl, timeout: 30000})

_http.interceptors.request.use(config => {
  // API地址中:id类型的URL, 需要替换成参数中相同名字的变量的值
  const url = config.url.match(/\/:(\w+)/g)
  const param = config.params || config.data

  // URL地址拼接的时候如果地址结尾出现:开头的字符例如(:id)则表示需要将id替换成参数中的值
  if (url && url.length) {
    url.map((item) => {
      config.url = config.url.replace(item, param && param[item.substr(2)] ? '/' + param[item.substr(2)] : '/')
      param && param[item.substr(2)] ? delete param[item.substr(2)] : null
    })
  }

  // 根据URL中api.cus等路径判断是否需要拼接token
  // console.log("user", config.url, store.state.custom)
  if (config.url.indexOf('.cus') > -1 && store.state.custom.token) {
    config.url = config.url + '?token=' + store.state.custom.token
  }

  if (config.url.indexOf('.sys') > -1 && store.state.sysUser.token) {
    config.url = config.url + '?token=' + store.state.sysUser.token
  }

  // POST数据时, 处理其中的JSON字段
  if (config.method === 'post' && config.data && typeof config.data === 'object') {
    if (config.file) {
      let file = new FormData()
      file.append('file', config.file)
      lodash.mapKeys(config.data, (value, key) => value !== null ? file.append(key, value) : null)
      config.data = file
      config.headers = {'Content-Type': 'multipart/form-data'}
    } else {
      config.headers = {'Content-Type': 'application/x-www-form-urlencoded'}
      // console.log("json parse before=", config.data)
      config.data = resTools.paramToJson(JSON.parse(JSON.stringify(config.data)))
      // console.log("json parse after=", config.data);
      let ret = ''
      for (let it in config.data) {
        if (typeof config.data[it] !== undefined)
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(typeof config.data[it] === 'object' ? JSON.stringify(config.data[it]) : config.data[it]) + '&'
      }
      config.data = ret
    }
  }

  if (store.state.vux) {
    if (!store.state.vux.isLoading) {
      store.commit('vux/UPDATE_LOADING', true)
    }
  }
  // iView.LoadingBar.start()
  return config
}, (error) => {
})

// 接收拦截器
_http.interceptors.response.use(response => {
  // post操作
  // if (response.config.method === 'post') {
  //     iView.Message.success('操作成功')
  // }
  // iView.LoadingBar.finish()
  if (store.state.vux) {
    if (response.config.method === 'post') {
      Vue.$vux.toast.text('操作成功', 'bottom')
    }
    if (store.state.vux.isLoading) {
      store.commit('vux/UPDATE_LOADING', false)
    }
  }

  response.data = resTools.fromJson(response.data)
  return new Promise((resolve, reject) => resolve(response.data))
}, (error) => {
  if (error.response) {
    // 错误处理
    if (store.state.vux) {
      if (error.response.data && error.response.data.error_message) {
        Vue.$vux.toast.text(error.response.data.error_message, 'bottom')
        store.commit('vux/UPDATE_LOADING', false)
      }
    }

    // 登录验证
    if (error.response.status === 401) {
      if (error.config.url.indexOf('api.cus') > -1) {
        store.commit('custom/SET_USER_LOGIN_OUT')
      }
    }
  }
  // iView.LoadingBar.finish()
  return Promise.reject()
})

const resTools = {
  // 获取到的数据进行 json字符串解析
  fromJson: obj => {
    if (typeof obj === 'string' && isNaN(parseInt(obj))) {
      try {
        obj = JSON.parse(obj)
      } catch (e) {
      }
    }
    if (obj instanceof Array) {
      obj.forEach(function (item) {
        item = resTools.fromJson(item)
      })
    }
    if (obj instanceof Object) {
      for (var i in obj) {
        obj[i] = resTools.fromJson(obj[i])
      }
    }
    return obj
  },
  // 发送到服务器的数据进行 json字符串转换
  paramToJson: data => {
    let objDeal = function (obj) {
      for (let key in obj) {
        if (typeof obj[key] === 'object' && key !== '$promise') {
          searchObject(obj[key])
        }
        if (obj[key] && (key.substr(-4, 4) === 'Json' || key === 'bizSetupJsonStr') && typeof obj[key] === 'object') {
          obj[key] = JSON.stringify(obj[key])
        }
      }
    }
    let searchObject = function (object) {
      if (object instanceof Array && object.length > 0) {
        object.forEach(function (item) {
          searchObject(item)
        })
      } else if (object instanceof Object) {
        objDeal(object)
      }
    }
    for (var key in data) {
      searchObject(data[key])
      if (typeof data[key] === 'object') {
        data[key] = resTools.paramToJson(data[key])
      }
    }
    return data
  }
}

export default _http
